module.exports = __webpack_public_path__ + "img/1071252397.70f6f410.png";